// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleCalypso as _skaleCalypso } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleCalypso chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1564830818
 * Chain Name: SKALE | Calypso NFT Hub
 * Default Block Explorer: https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com
 * Default RPC URL: https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleCalypso } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleCalypso,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleCalypso = createCommon({
	..._skaleCalypso,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
